// deskripsiJalur.js — Deskripsi & fitur modul yang disesuaikan per jalur (Tamtama/Bintara)
//
// Soal dan cara penilaian SAMA untuk kedua jalur.
// Hanya teks deskripsi/instruksi yang berbeda, menyesuaikan fokus tiap jalur:
// - Tamtama: kapabilitas fisik, ketahanan, kerja tim, eksekusi tugas lapangan
// - Bintara: kepemimpinan, analisis, komunikasi, kemampuan manajerial

const DESKRIPSI_PER_JALUR = {
  kraepelin: {
    tamtama: {
      desc: 'Deret penjumlahan angka berurutan untuk mengukur daya tahan kerja dan konsistensi — kemampuan krusial bagi Tamtama yang dituntut bertahan dalam tugas lapangan jangka panjang.',
      features: [
        'Lembar angka digital dengan numpad untuk simulasi tes asli',
        'Timer otomatis per kolom (90 detik) — latih ketahanan kerja',
        'Grafik kestabilan & kecepatan kerja di bawah tekanan',
        'Analisis konsistensi per kolom — penting untuk tugas berulang di lapangan',
      ],
    },
    bintara: {
      desc: 'Deret penjumlahan angka berurutan untuk mengukur ketelitian dan stabilitas kerja — indikator penting kemampuan Bintara dalam menjaga performa saat memimpin dan mengambil keputusan cepat.',
      features: [
        'Lembar angka digital dengan numpad untuk simulasi tes asli',
        'Timer otomatis per kolom (90 detik) — latih fokus di bawah tekanan',
        'Grafik kestabilan & kecepatan kerja sebagai indikator kepemimpinan',
        'Analisis konsistensi per kolom — relevan untuk pengambilan keputusan',
      ],
    },
  },
  kecermatan: {
    tamtama: {
      desc: 'Bandingkan tiga kolom huruf atau angka dan tentukan mana yang sama — melatih kewaspadaan dan ketelitian yang dibutuhkan saat bertugas di lapangan.',
      features: [
        'Format NNC-2 resmi TNI',
        '30 soal acak dari bank soal',
        '15 detik per soal — latih kecepatan reaksi',
        'Skor dan analisis otomatis',
      ],
    },
    bintara: {
      desc: 'Bandingkan tiga kolom huruf atau angka dan tentukan mana yang sama — mengukur ketelitian dalam memeriksa detail administratif dan laporan, kemampuan penting bagi Bintara.',
      features: [
        'Format NNC-2 resmi TNI',
        '30 soal acak dari bank soal',
        '15 detik per soal — latih ketelitian cepat',
        'Skor dan analisis otomatis',
      ],
    },
  },
  logika: {
    tamtama: {
      desc: 'Deret angka, aritmatika cerita, dan penalaran numerik dasar — bekal yang cukup untuk menjalankan instruksi teknis dan tugas lapangan secara efektif.',
      features: [
        '3 mode: Deret Angka / Aritmatika / Campuran',
        '30 soal per sesi dengan timer 25 menit',
        'Skor Deret & Aritmatika ditampilkan terpisah',
        'Latihan dasar yang wajib dikuasai semua Casis',
      ],
    },
    bintara: {
      desc: 'Deret angka, aritmatika cerita, dan penalaran numerik — kemampuan ini sangat ditekankan untuk Bintara karena berkaitan langsung dengan analisis dan pengambilan keputusan saat memimpin regu.',
      features: [
        '3 mode: Deret Angka / Aritmatika / Campuran',
        '30 soal per sesi dengan timer 25 menit',
        'Skor Deret & Aritmatika ditampilkan terpisah',
        'Porsi soal akademik ini lebih ditekankan untuk jalur Bintara',
      ],
    },
  },
  verbal: {
    tamtama: {
      desc: 'Sinonim, antonim, dan kata ganjil — mengukur kemampuan dasar berbahasa untuk memahami instruksi dan komunikasi sehari-hari di satuan.',
      features: [
        '3 mode: Sinonim & Antonim / Kata Ganjil / Campuran',
        '30 soal per sesi dengan timer 25 menit',
        'Skor tiap kategori ditampilkan terpisah',
        'Fokus pada pemahaman instruksi dasar',
      ],
    },
    bintara: {
      desc: 'Sinonim, antonim, dan kata ganjil — kemampuan bahasa yang kuat penting bagi Bintara untuk menyampaikan instruksi dengan jelas dan menulis laporan secara efektif.',
      features: [
        '3 mode: Sinonim & Antonim / Kata Ganjil / Campuran',
        '30 soal per sesi dengan timer 25 menit',
        'Skor tiap kategori ditampilkan terpisah',
        'Relevan untuk kemampuan komunikasi & administrasi',
      ],
    },
  },
  figural: {
    tamtama: {
      desc: 'Rotasi bangun, bayangan cermin, pola matriks, dan deret gambar — melatih orientasi spasial yang berguna untuk navigasi dan operasi lapangan.',
      features: [
        '3 mode: Rotasi & Bayangan / Pola Matriks / Campuran',
        '50 soal visual interaktif dengan SVG',
        'Skor per kategori ditampilkan terpisah',
        'Berguna untuk kemampuan orientasi & navigasi lapangan',
      ],
    },
    bintara: {
      desc: 'Rotasi bangun, bayangan cermin, pola matriks, dan deret gambar — mengukur kemampuan analisis visual dan pemecahan masalah, relevan untuk perencanaan taktis.',
      features: [
        '3 mode: Rotasi & Bayangan / Pola Matriks / Campuran',
        '50 soal visual interaktif dengan SVG',
        'Skor per kategori ditampilkan terpisah',
        'Relevan untuk perencanaan taktis & analisis situasi',
      ],
    },
  },
  kepribadian: {
    tamtama: {
      desc: 'Kuesioner EPPS & Papi Kostick untuk memetakan karakter — fokus pada kedisiplinan, loyalitas, ketahanan mental, dan kemampuan bekerja sebagai bagian dari tim.',
      features: [
        '3 mode: EPPS / Papi Kostick / Campuran',
        '100 soal dengan timer 45 menit',
        'Profil kepribadian: kedisiplinan, loyalitas, kerja tim',
        'Catatan: bukan diagnosis klinis, hanya simulasi latihan',
      ],
    },
    bintara: {
      desc: 'Kuesioner EPPS & Papi Kostick untuk memetakan karakter — fokus tambahan pada potensi kepemimpinan, kemampuan komunikasi, dan pengambilan keputusan.',
      features: [
        '3 mode: EPPS / Papi Kostick / Campuran',
        '100 soal dengan timer 45 menit',
        'Profil kepribadian: kepemimpinan, komunikasi, analisis',
        'Catatan: bukan diagnosis klinis, hanya simulasi latihan',
      ],
    },
  },
  akademik: {
    tamtama: {
      desc: 'Soal logika, numerik, dan verbal dasar setara TPA — bekal akademik dasar yang wajib dikuasai untuk mengikuti pendidikan dan pelatihan teknis.',
      features: [
        '3 mode: Sains / Sosial & Bahasa / Campuran TPA',
        '80 soal dengan timer 75 menit',
        'Pembahasan jawaban setelah tes selesai',
        'Fokus pada penguasaan dasar — porsi soal lebih ringan',
      ],
    },
    bintara: {
      desc: 'Soal logika, numerik, dan verbal setara TPA — kemampuan akademik ini sangat ditekankan dalam seleksi Bintara karena berkaitan dengan tugas administratif dan analisis.',
      features: [
        '3 mode: Sains / Sosial & Bahasa / Campuran TPA',
        '80 soal dengan timer 75 menit',
        'Pembahasan jawaban setelah tes selesai',
        'Porsi soal akademik ini lebih ditekankan untuk jalur Bintara',
      ],
    },
  },
  menggambar: {
    tamtama: {
      desc: 'Wartegg, gambar pohon, dan gambar orang untuk menilai stabilitas emosi dan ketahanan mental dalam menghadapi tugas lapangan.',
      features: [
        'Panduan & instruksi tiap jenis tes (Wartegg, Pohon, Orang)',
        'Foto hasil gambar langsung via kamera HP/laptop',
        'Analisis psikologis otomatis menggunakan AI',
        'Skor, kekuatan, dan rekomendasi setelah analisis',
      ],
    },
    bintara: {
      desc: 'Wartegg, gambar pohon, dan gambar orang untuk menilai kematangan emosi dan kepribadian — relevan untuk menilai kesiapan memikul tanggung jawab kepemimpinan.',
      features: [
        'Panduan & instruksi tiap jenis tes (Wartegg, Pohon, Orang)',
        'Foto hasil gambar langsung via kamera HP/laptop',
        'Analisis psikologis otomatis menggunakan AI',
        'Skor, kekuatan, dan rekomendasi setelah analisis',
      ],
    },
  },
  armyalpha: {
    tamtama: {
      desc: 'Tes logika dan instruksi cepat menggunakan simbol, kode, dan gambar — melatih reaksi cepat terhadap instruksi, penting untuk eksekusi perintah di lapangan.',
      features: [
        '3 mode: Simbol & Aritmatika / Analogi & Penalaran / Campuran',
        '50 soal dengan timer 30 menit',
        'Skor otomatis berdasarkan kecepatan & akurasi',
        'Fokus pada kecepatan eksekusi instruksi',
      ],
    },
    bintara: {
      desc: 'Tes logika dan instruksi cepat menggunakan simbol, kode, dan gambar — mengukur kemampuan memahami dan menerjemahkan instruksi kompleks untuk diteruskan ke anggota regu.',
      features: [
        '3 mode: Simbol & Aritmatika / Analogi & Penalaran / Campuran',
        '50 soal dengan timer 30 menit',
        'Skor otomatis berdasarkan kecepatan & akurasi',
        'Relevan untuk kemampuan menerjemahkan instruksi ke tim',
      ],
    },
  },
};

/**
 * Ambil deskripsi modul yang sesuai dengan jalur user
 * @param {string} modId - id modul (misal: 'kraepelin')
 * @param {string} jalur - 'tamtama' | 'bintara' | null
 * @returns {object|null} { desc, features } atau null jika tidak ada data khusus
 */
export function getDeskripsiModul(modId, jalur) {
  const data = DESKRIPSI_PER_JALUR[modId];
  if (!data) return null;
  if (jalur === 'bintara') return data.bintara;
  return data.tamtama; // default ke tamtama jika jalur null/tidak dikenali
}
